import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import { numberToTextEng, numberToTextSwe } from '@fora-monorepo/string-utils';

import { combineResources } from '../utils/combineResources';

export const i18nextInit = ({
  localCopySV,
  dittoCopySV,
  debugMode,
}: {
  localCopySV: any;
  dittoCopySV?: any;
  debugMode: boolean;
}) => {
  const localResources = {
    sv: { translation: localCopySV },
    // en: { translation: localCopyEN },
  };

  const combinedResources = dittoCopySV
    ? combineResources({ ditto_component_library: { sv: dittoCopySV } }, localResources)
    : localResources;

  if (i18next.isInitialized) {
    // for multiple inits, eg in storybook, append the keys to prevent overwrite
    i18next.addResourceBundle('sv', 'translation', combinedResources?.sv?.translation);
  } else {
    i18next.use(initReactI18next).init({
      fallbackLng: 'sv',
      lng: 'sv', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
      // you can use the i18next.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
      // if you're using a language detector, do not define the lng option
      debug: debugMode && process.env.NODE_ENV !== 'test',
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
      resources: combinedResources,
    });

    i18next.services.formatter?.add('numberToText', (value, lng, _options) => {
      return lng !== 'sv' ? numberToTextEng(value) : numberToTextSwe(value);
    });
  }
};
